import React, {useState} from "react";
import {useTranslation} from "@unibuddy/intl";
import {Stack, Box, Text, Heading} from "@unibuddy/patron";
import {FormikHelpers} from "formik";

import {IntlNamespaces} from "../../../../translations/types";
import {
    INTL_RESET_PASSWORD,
    INTL_RESET_REQUESTED,
    INTL_RESET_SENT,
} from "../../../../translations/passwordReset";
import {AuthPageContainer} from "../../../../widgets/modules/RegisterNew/components/AuthPageContainer";
import {PasswordResetHeader} from "./PasswordResetHeader";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {PasswordResetForm} from "./PasswordResetForm";

export type PasswordResetProps = {
    loginLink: string;
    onRequestPasswordReset: (
        {email}: {email: string},
        formActions: FormikHelpers<FormValues>,
    ) => void;
};
type FormValues = {
    email: string;
};

export const PasswordReset = ({loginLink, onRequestPasswordReset}: PasswordResetProps) => {
    const {t} = useTranslation([IntlNamespaces.PASSWORD_RESET, IntlNamespaces.VALIDATIONS]);
    const [passwordRequested, setPasswordRequested] = useState(false);

    const onPasswordResetSubmit = async (email: string, formActions: FormikHelpers<FormValues>) => {
        await Promise.resolve(onRequestPasswordReset({email}, formActions));
        setPasswordRequested(true);
    };

    return (
        <Box display="flex" justifyContent="center">
            <Box w="100%">
                <AuthPageContainer>
                    <PageTitle
                        title={t(INTL_RESET_PASSWORD.key, INTL_RESET_PASSWORD.defaultValue)}
                    />
                    <PasswordResetHeader loginLink={loginLink} />
                    <Box>
                        <Stack space="medium">
                            <PasswordResetForm onPasswordResetSubmit={onPasswordResetSubmit} />
                        </Stack>
                        <Box aria-live="polite">
                            {passwordRequested && (
                                <Box
                                    marginTop="medium"
                                    bgColor="green100"
                                    padding="medium"
                                    borderRadius="xxsmall"
                                >
                                    <Stack space="small">
                                        <Heading color="green900" size="xxsmall" level={2}>
                                            {t(
                                                INTL_RESET_REQUESTED.key,
                                                INTL_RESET_REQUESTED.defaultValue,
                                            )}
                                        </Heading>
                                        <Text size="small" color="green900">
                                            {t(INTL_RESET_SENT.key, INTL_RESET_SENT.defaultValue)}
                                        </Text>
                                    </Stack>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </AuthPageContainer>
            </Box>
        </Box>
    );
};
